import React from "react";
import { Thread, ChatMode } from "../types";
import { ThreadList } from "./ThreadList";

interface SidebarProps {
  threads: Thread[];
  currentThread: Thread | null;
  onThreadSelect: (thread: Thread) => void;
  onNewThread: () => void;
  onDeleteThread: (threadId: string) => void;
  chatMode: ChatMode;
  onModeChange: (mode: ChatMode) => void;
  isConnected: boolean;
  onRetryConnection: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({
  threads,
  currentThread,
  onThreadSelect,
  onNewThread,
  onDeleteThread,
}) => {
  return (
    <div className='w-64 bg-background border-r flex flex-col'>
      {/* Thread List */}
      <div className='flex-1 overflow-hidden'>
        <div className='p-4'>
          <h3 className='prose-h3'>Conversations</h3>
        </div>
        <ThreadList
          threads={threads}
          currentThreadId={currentThread?.id || null}
          onThreadSelect={onThreadSelect}
          onNewThread={onNewThread}
          onDeleteThread={onDeleteThread}
        />
      </div>
    </div>
  );
};
